/**
 * Daily Notification Service
 * Handles background notifications that trigger every 24 hours
 * Works for both logged-in and logged-out users
 */

const DAILY_NOTIFICATION_KEY = 'dailyNotificationData';
const LAST_NOTIFICATION_KEY = 'lastNotificationTime';
const NOTIFICATION_INDEX_KEY = 'notificationIndex';
const USER_STATUS_KEY = 'userNotificationStatus';
const SOCIAL_VISITOR_KEY = 'socialVisitorDetected';
const INACTIVE_VISITOR_KEY = 'inactiveVisitorDetected';
const FIRST_VISIT_KEY = 'firstVisitTime';

// Notification messages for different user types
const NOTIFICATION_MESSAGES = {
  guest: [
    {
      title: "Start Your Learning Journey Today! 🚀",
      body: "Join thousands of Ethiopian students mastering their subjects online. Register for just 100 birr/year and start learning right now!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-1",
      url: "/register"
    },
    {
      title: "Your Future Starts Here 🎓",
      body: "Don't wait! Create your account today and access hundreds of lessons, exams, and study materials — all in one place.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-2",
      url: "/register"
    },
    {
      title: "Learn Smarter, Not Harder 📚",
      body: "Our platform is built for Ethiopian students just like you. Sign up for just 100 birr/year and discover a better way to study.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-3",
      url: "/register"
    },
    {
      title: "Thousands Are Already Learning 🌟",
      body: "Students nationwide use Tinat Academy to prepare for exams and excel in school. Don't be left behind — join today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-4",
      url: "/register"
    },
    {
      title: "Ready to Ace Your Exams? ✅",
      body: "Register now and get instant access to model exams, past papers, video lessons, and AI-powered study help!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-5",
      url: "/register"
    },
    {
      title: "Transform Your Study Habits 📖",
      body: "Stop struggling with traditional methods. Join Tinat Academy and study smarter with our AI-powered tools.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-6",
      url: "/register"
    },
    {
      title: "Your Success Story Begins Now 🌟",
      body: "Every successful journey starts with a single step. Take yours today by joining Ethiopia's top e-learning platform.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-7",
      url: "/register"
    },
    {
      title: "Don't Miss Out! 🎯",
      body: "While you're waiting, others are getting ahead. Register now and start your path to academic excellence.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-8",
      url: "/register"
    },
    {
      title: "Study Like a Champion 🏆",
      body: "Champions don't wait for opportunities, they create them. Start your championship journey with Tinat Academy today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-9",
      url: "/register"
    },
    {
      title: "Your Parents Will Be Proud 😊",
      body: "Show them you're serious about your future. Join Tinat Academy and excel in your studies starting today.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-10",
      url: "/register"
    },
    {
      title: "Beat Exam Anxiety 🧘",
      body: "Prepare with confidence! Our platform gives you everything you need to walk into any exam room ready to succeed.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-11",
      url: "/register"
    },
    {
      title: "Learn at Your Own Pace ⏰",
      body: "No more rushing to catch up. Study anytime, anywhere with Tinat Academy's flexible learning system.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-12",
      url: "/register"
    },
    {
      title: "Join the Smart Students 💡",
      body: "The brightest students are already here. Don't get left behind in the digital learning revolution!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-13",
      url: "/register"
    },
    {
      title: "Your Dream University Awaits 🎓",
      body: "Every university admission starts with good grades. Start building your future with Tinat Academy today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-14",
      url: "/register"
    },
    {
      title: "Study Less, Score More 📈",
      body: "Our proven methods help you study efficiently. Get better results in less time with Tinat Academy.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-15",
      url: "/register"
    },
    {
      title: "Be Among the Best 🌟",
      body: "Top students use modern tools. Join Ethiopia's leading e-learning platform and elevate your studies.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-16",
      url: "/register"
    },
    {
      title: "Your Friends Are Already Here 👥",
      body: "Don't study alone when everyone's learning together online. Join your classmates on Tinat Academy!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-17",
      url: "/register"
    },
    {
      title: "No More Exam Surprises 🔍",
      body: "Know exactly what to expect in every exam. Join Tinat Academy and access thousands of practice questions.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-18",
      url: "/register"
    },
    {
      title: "Study Like It's 2024 📱",
      body: "Why use outdated methods? Modern problems need modern solutions. Join the digital learning revolution!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-19",
      url: "/register"
    },
    {
      title: "Your Teachers Will Notice 📝",
      body: "Improve your grades and watch your teachers' reactions. Start your improvement journey today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-20",
      url: "/register"
    },
    {
      title: "Future-Proof Your Education 🚀",
      body: "Digital skills are essential. Learn with modern tools and prepare for tomorrow's challenges today.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-21",
      url: "/register"
    },
    {
      title: "Stop Procrastinating ⏰",
      body: "The best time to start was yesterday. The second best time is now. Join Tinat Academy today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-22",
      url: "/register"
    },
    {
      title: "Study With AI Tutor 🤖",
      body: "Get 24/7 help from your AI assistant. Never get stuck on a problem again with Tinat Academy.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-23",
      url: "/register"
    },
    {
      title: "Join 10,000+ Happy Students 😊",
      body: "Our students love learning with us. Find out why by joining Tinat Academy's growing community!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-24",
      url: "/register"
    },
    {
      title: "Your Competition is Here 🏃",
      body: "Other students are getting ahead every day. Don't fall behind - join the learning revolution now!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-25",
      url: "/register"
    },
    {
      title: "Master Every Subject 📚",
      body: "From Math to English, Science to History - we've got everything you need to excel in school.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-26",
      url: "/register"
    },
    {
      title: "Study Offline Too 📱",
      body: "No internet? No problem! Download lessons and study anywhere with Tinat Academy's offline mode.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-27",
      url: "/register"
    },
    {
      title: "Parents Love Us Too 👨‍👩‍👧‍👦",
      body: "See why parents across Ethiopia trust Tinat Academy for their children's education. Join today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-28",
      url: "/register"
    },
    {
      title: "Last Chance Today! ⏰",
      body: "Don't let another day pass without investing in your future. Register in just 2 minutes and start learning!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-29",
      url: "/register"
    },
    {
      title: "Your Future Self Will Thank You 🙏",
      body: "Imagine looking back in 5 years. Start building that future today with Tinat Academy!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-guest-30",
      url: "/register"
    }
  ],
  loggedIn: [
    {
      title: "Welcome Back! Time to Learn 🎓",
      body: "Your courses and study materials are ready. Keep up the great work and continue your learning journey today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-1",
      url: "/courses"
    },
    {
      title: "Your Daily Study Reminder 📚",
      body: "A few minutes of study every day adds up to big results. Log in and tackle today's lesson!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-2",
      url: "/courses"
    },
    {
      title: "New Content Waiting for You! 🌟",
      body: "Fresh lessons and practice materials have been added. Visit Tinat Academy and explore what's new!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-3",
      url: "/courses"
    },
    {
      title: "Keep Your Study Streak Alive! 🔥",
      body: "You're doing amazing! Continue your daily study habit and stay ahead in your exams.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-4",
      url: "/courses"
    },
    {
      title: "Practice Makes Perfect! 📝",
      body: "Test your knowledge with today's practice questions and track your progress.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-5",
      url: "/courses"
    },
    {
      title: "Your Brain Needs Exercise 💪",
      body: "Just like muscles, your brain gets stronger with daily practice. Start today's workout!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-6",
      url: "/courses"
    },
    {
      title: "Don't Break the Chain ⛓",
      body: "You've built momentum! Keep your daily study streak going and watch your grades soar.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-7",
      url: "/courses"
    },
    {
      title: "Today's Challenge Awaits 🎯",
      body: "We've prepared a special challenge for you today. Can you rise to the occasion?",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-8",
      url: "/courses"
    },
    {
      title: "Your Future Self is Watching 👀",
      body: "Every study session today builds the successful person you'll become tomorrow.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-9",
      url: "/courses"
    },
    {
      title: "Smart Students Study Daily 🧠",
      body: "It's not about studying more, it's about studying consistently. Your daily lesson is ready!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-10",
      url: "/courses"
    },
    {
      title: "Beat Yesterday's Score 📈",
      body: "Challenge yourself to do better than yesterday. Your progress tracking is updated!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-11",
      url: "/courses"
    },
    {
      title: "Knowledge is Power! ⚡",
      body: "Every lesson you complete makes you stronger. Time to power up your brain!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-12",
      url: "/courses"
    },
    {
      title: "Your Teachers Are Proud 👨‍🏫",
      body: "Keep making your teachers proud with consistent study habits. Today's lesson is waiting!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-13",
      url: "/courses"
    },
    {
      title: "Exam Success Starts Now 🏆",
      body: "Every exam victory begins with daily preparation. Start your winning streak today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-14",
      url: "/courses"
    },
    {
      title: "Learning is Fun! 🎮",
      body: "Who said studying can't be fun? We've gamified your lessons. Come play and learn!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-15",
      url: "/courses"
    },
    {
      title: "Your Goals Are Closer 🎯",
      body: "Every study session brings you one step closer to your academic goals. Keep going!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-16",
      url: "/courses"
    },
    {
      title: "Study Like a Pro 🌟",
      body: "Top students have one thing in common: consistency. Join their ranks today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-17",
      url: "/courses"
    },
    {
      title: "Your Brain is Growing 🌱",
      body: "With every lesson, your neural pathways get stronger. Feed your brain today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-18",
      url: "/courses"
    },
    {
      title: "Success Loves Consistency �",
      body: "Successful people show up every day. Show up for your studies today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-19",
      url: "/courses"
    },
    {
      title: "Today's Mission: Learn! 🚀",
      body: "Your mission, should you choose to accept it: complete today's lesson and level up!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-20",
      url: "/courses"
    },
    {
      title: "Knowledge Compounds Daily 📊",
      body: "Like interest, knowledge compounds. Small daily efforts lead to huge results over time!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-21",
      url: "/courses"
    },
    {
      title: "Your Competition is Studying 🏃",
      body: "While you rest, others are preparing. Stay ahead with your daily lesson!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-22",
      url: "/courses"
    },
    {
      title: "Build Your Future Daily 🏗️",
      body: "Every brick of knowledge you lay today builds the mansion of your success tomorrow.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-23",
      url: "/courses"
    },
    {
      title: "Excellence is a Habit 🌟",
      body: "Excellence isn't an act, it's a habit. Build yours today with your lesson!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-24",
      url: "/courses"
    },
    {
      title: "Your Potential is Limitless ♾️",
      body: "Unlock more of your potential with every study session. Start unlocking today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-25",
      url: "/courses"
    },
    {
      title: "Study Smarter, Not Longer ⏰",
      body: "Quality over quantity! Our focused lessons help you learn more in less time.",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-26",
      url: "/courses"
    },
    {
      title: "Your Dreams Need Action 💭",
      body: "Dreams need daily action to become reality. Take action today with your lesson!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-27",
      url: "/courses"
    },
    {
      title: "Become Unstoppable 🚀",
      body: "Consistent daily learning makes you unstoppable in your academic journey. Start today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-28",
      url: "/courses"
    },
    {
      title: "The World Needs Your Genius 🌍",
      body: "Your unique perspective and skills are needed. Develop them daily with your lessons!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-29",
      url: "/courses"
    },
    {
      title: "Greatness Awaits You 👑",
      body: "Every great journey begins with a single step. Take your step today with your lesson!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "daily-logged-30",
      url: "/courses"
    }
  ],
  socialVisitor: [
    {
      title: "Don't Miss Out! 🎯",
      body: "You found Tinat Academy for a reason! Don't let this opportunity pass. See what everyone's talking about!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "social-visitor-1",
      url: "/register"
    },
    {
      title: "Your Curiosity Brought You Here 🔍",
      body: "You clicked the link for a reason! Satisfy that curiosity - explore Tinat Academy now!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "social-visitor-2",
      url: "/register"
    },
    {
      title: "Don't Just Look, Explore! 👀",
      body: "You're already here - why not take a quick tour? See how Tinat Academy can transform your studies!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "social-visitor-3",
      url: "/register"
    },
    {
      title: "That Link Was a Sign ✨",
      body: "Finding Tinat Academy wasn't accident! It's your sign to start learning smarter today!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "social-visitor-4",
      url: "/register"
    },
    {
      title: "Your Friends Want You Here 👥",
      body: "Someone shared this with you because they care! Join them on Tinat Academy and succeed together!",
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: "social-visitor-5",
      url: "/register"
    }
  ]
};

class DailyNotificationService {
  constructor() {
    this.isSupported = 'serviceWorker' in navigator && 'Notification' in window;
    this.registration = null;
    this.isInitialized = false;
  }

  /**
   * Initialize the notification service
   */
  async initialize() {
    if (!this.isSupported) {
      console.warn('Notifications not supported in this browser');
      return false;
    }

    try {
      // Track first visit for all visitors
      this.trackFirstVisit();

      // Get service worker registration
      this.registration = await navigator.serviceWorker.ready;

      // Request notification permission
      const permission = await this.requestPermission();

      if (permission === 'granted') {
        this.isInitialized = true;
        this.scheduleDailyNotifications();
        return true;
      } else {
        console.warn('Notification permission denied');
        return false;
      }
    } catch (error) {
      console.error('Failed to initialize notification service:', error);
      return false;
    }
  }

  /**
   * Request notification permission
   */
  async requestPermission() {
    if (!('Notification' in window)) {
      return 'denied';
    }

    if (Notification.permission === 'granted') {
      return 'granted';
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      return permission;
    }

    return Notification.permission;
  }

  /**
   * Schedule daily notifications using service worker
   */
  async scheduleDailyNotifications() {
    if (!this.isInitialized || !this.registration) {
      return;
    }

    try {
      // Send message to service worker to schedule notifications
      this.registration.active.postMessage({
        type: 'SCHEDULE_DAILY_NOTIFICATIONS',
        data: {
          messages: NOTIFICATION_MESSAGES,
          interval: 24 * 60 * 60 * 1000 // 24 hours
        }
      });

      // Register periodic sync for background notifications
      if ('periodicSync' in this.registration) {
        try {
          await this.registration.periodicSync.register('daily-notification-sync', {
            minInterval: 24 * 60 * 60 * 1000 // 24 hours
          });
          console.log('[NotificationService] Periodic sync registered for background notifications');
        } catch (error) {
          console.warn('[NotificationService] Periodic sync registration failed:', error);
          // Fallback: use setTimeout for immediate testing
          this.scheduleFallbackNotification();
        }
      } else {
        console.warn('[NotificationService] Periodic Sync API not supported');
        // Fallback: use setTimeout for immediate testing
        this.scheduleFallbackNotification();
      }
    } catch (error) {
      console.error('[NotificationService] Failed to schedule notifications:', error);
    }
  }

  /**
   * Fallback notification scheduler using setTimeout
   */
  scheduleFallbackNotification() {
    if (!this.isInitialized) return;

    // Check every hour if notifications are due
    setTimeout(() => {
      if (this.isInitialized) {
        this.checkAndShowNotification();
        this.scheduleFallbackNotification(); // Schedule next check
      }
    }, 60 * 60 * 1000); // 1 hour
  }

  /**
   * Check and show notification (fallback method)
   */
  async checkAndShowNotification() {
    try {
      const lastNotification = localStorage.getItem('lastNotificationTime');
      const now = Date.now();
      const interval = 24 * 60 * 60 * 1000; // 24 hours

      if (!lastNotification || (now - parseInt(lastNotification)) >= interval) {
        const notification = this.getNextNotification();
        if (notification) {
          await this.showNotification(notification);
          localStorage.setItem('lastNotificationTime', now.toString());
        }
      }
    } catch (error) {
      console.error('[NotificationService] Failed to check notification:', error);
    }
  }

  /**
   * Update user status (logged in/out)
   */
  async updateUserStatus(isLoggedIn, userInfo = null) {
    try {
      const status = {
        isLoggedIn,
        userInfo,
        lastUpdated: Date.now()
      };

      // Store in localStorage for fallback
      localStorage.setItem(USER_STATUS_KEY, JSON.stringify(status));

      // Store in IndexedDB for service worker access
      if (this.isInitialized && this.registration) {
        await this.storeUserStatusInIndexedDB(status);
      }

      // Reschedule notifications with new user status
      if (this.isInitialized) {
        this.scheduleDailyNotifications();
      }
    } catch (error) {
      console.error('Failed to update user status:', error);
    }
  }

  /**
   * Store user status in IndexedDB for service worker access
   */
  async storeUserStatusInIndexedDB(status) {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('TinatNotifications', 1);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction(['notifications'], 'readwrite');
        const store = transaction.objectStore('notifications');

        const putRequest = store.put({
          id: 'userStatus',
          data: status,
          timestamp: Date.now()
        });

        putRequest.onerror = () => reject(putRequest.error);
        putRequest.onsuccess = () => resolve();
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('notifications')) {
          db.createObjectStore('notifications', { keyPath: 'id' });
        }
      };
    });
  }

  /**
   * Get current notification index
   */
  getNotificationIndex(userType) {
    try {
      const key = `${NOTIFICATION_INDEX_KEY}_${userType}`;
      const index = localStorage.getItem(key);
      return index ? parseInt(index, 10) : 0;
    } catch {
      return 0;
    }
  }

  /**
   * Increment notification index
   */
  incrementNotificationIndex(userType) {
    try {
      const key = `${NOTIFICATION_INDEX_KEY}_${userType}`;
      const current = this.getNotificationIndex(userType);
      const messages = NOTIFICATION_MESSAGES[userType] || [];
      const nextIndex = (current + 1) % messages.length;
      localStorage.setItem(key, nextIndex.toString());
      return nextIndex;
    } catch {
      return 0;
    }
  }

  /**
   * Track first visit for all visitors
   */
  trackFirstVisit() {
    try {
      // Check if this is first visit
      const firstVisit = localStorage.getItem(FIRST_VISIT_KEY);
      const alreadyTracked = localStorage.getItem(INACTIVE_VISITOR_KEY);

      if (!firstVisit && !alreadyTracked) {
        const visitTime = Date.now();
        localStorage.setItem(FIRST_VISIT_KEY, visitTime.toString());
        localStorage.setItem(INACTIVE_VISITOR_KEY, 'true');

        // Also store in IndexedDB for service worker access
        this.storeFirstVisitInIndexedDB(visitTime);

        console.log('First visit tracked, visitor will receive daily notifications');
        return true;
      }

      return false;
    } catch (error) {
      console.error('Failed to track first visit:', error);
      return false;
    }
  }

  /**
   * Store first visit in IndexedDB for service worker access
   */
  async storeFirstVisitInIndexedDB(visitTime) {
    try {
      const request = indexedDB.open('TinatNotifications', 1);

      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction(['notifications'], 'readwrite');
        const store = transaction.objectStore('notifications');

        store.put({
          id: 'firstVisitTime',
          timestamp: visitTime
        });
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('notifications')) {
          db.createObjectStore('notifications', { keyPath: 'id' });
        }
      };
    } catch (error) {
      console.error('Failed to store first visit in IndexedDB:', error);
    }
  }

  /**
   * Check if user should receive notifications (for all visitors)
   */
  shouldReceiveNotifications() {
    try {
      // All visitors who have been to the site should receive notifications
      const hasVisited = localStorage.getItem(FIRST_VISIT_KEY);
      return !!hasVisited;
    } catch (error) {
      console.error('Failed to check notification eligibility:', error);
      return false;
    }
  }
  detectSocialVisitor() {
    try {
      // Check if already detected
      const alreadyDetected = localStorage.getItem(SOCIAL_VISITOR_KEY);
      if (alreadyDetected) {
        return false;
      }

      // Check referrer for social media sources
      const referrer = document.referrer || '';
      const socialDomains = [
        'facebook.com', 'fb.com', 'twitter.com', 'x.com', 'instagram.com',
        'tiktok.com', 'linkedin.com', 'telegram.org', 'whatsapp.com',
        'youtube.com', 't.me', 'm.facebook.com'
      ];

      const isFromSocial = socialDomains.some(domain =>
        referrer.toLowerCase().includes(domain)
      );

      if (isFromSocial) {
        localStorage.setItem(SOCIAL_VISITOR_KEY, 'true');
        // Also store in IndexedDB for service worker access
        this.storeSocialVisitorInIndexedDB();
        return true;
      }

      return false;
    } catch (error) {
      console.error('Failed to detect social visitor:', error);
      return false;
    }
  }

  /**
   * Store social visitor status in IndexedDB for service worker access
   */
  async storeSocialVisitorInIndexedDB() {
    try {
      const request = indexedDB.open('TinatNotifications', 1);

      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction(['notifications'], 'readwrite');
        const store = transaction.objectStore('notifications');

        store.put({
          id: 'socialVisitorDetected',
          detected: true,
          timestamp: Date.now()
        });
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('notifications')) {
          db.createObjectStore('notifications', { keyPath: 'id' });
        }
      };
    } catch (error) {
      console.error('Failed to store social visitor in IndexedDB:', error);
    }
  }

  /**
   * Mark social visitor as handled
   */
  markSocialVisitorHandled() {
    try {
      localStorage.setItem(SOCIAL_VISITOR_KEY, 'true');
      // Also store in IndexedDB for service worker access
      this.storeSocialVisitorInIndexedDB();
    } catch (error) {
      console.error('Failed to mark social visitor:', error);
    }
  }

  /**
   * Get next notification to show
   */
  getNextNotification() {
    try {
      const statusData = localStorage.getItem(USER_STATUS_KEY);
      const status = statusData ? JSON.parse(statusData) : { isLoggedIn: false };

      // Check if this is a social media visitor first
      if (this.detectSocialVisitor()) {
        const socialMessages = NOTIFICATION_MESSAGES.socialVisitor || [];
        if (socialMessages.length > 0) {
          const index = this.getNotificationIndex('socialVisitor');
          const notification = socialMessages[index];

          return {
            ...notification,
            userType: 'socialVisitor'
          };
        }
      }

      // For all visitors (including inactive ones), use guest messages
      // This ensures everyone who visits the site gets daily notifications
      const userType = 'guest'; // Always use guest messages for daily notifications
      const messages = NOTIFICATION_MESSAGES[userType] || [];

      if (messages.length === 0) {
        return null;
      }

      const index = this.getNotificationIndex(userType);
      const notification = messages[index];

      return {
        ...notification,
        userType
      };
    } catch (error) {
      console.error('Failed to get next notification:', error);
      return null;
    }
  }

  /**
   * Check if 24 hours have passed since last notification
   */
  shouldShowNotification() {
    try {
      const lastNotification = localStorage.getItem(LAST_NOTIFICATION_KEY);
      if (!lastNotification) {
        return true;
      }

      const lastTime = parseInt(lastNotification, 10);
      const now = Date.now();
      const timeDiff = now - lastTime;

      return timeDiff >= 24 * 60 * 60 * 1000; // 24 hours
    } catch {
      return true;
    }
  }

  /**
   * Record that a notification was shown
   */
  recordNotificationShown(userType) {
    try {
      localStorage.setItem(LAST_NOTIFICATION_KEY, Date.now().toString());
      this.incrementNotificationIndex(userType);
    } catch (error) {
      console.error('Failed to record notification:', error);
    }
  }

  /**
   * Show an immediate notification (for testing)
   */
  async showImmediateNotification() {
    if (!this.isInitialized) {
      const initialized = await this.initialize();
      if (!initialized) {
        return false;
      }
    }

    const notification = this.getNextNotification();
    if (!notification) {
      return false;
    }

    try {
      await this.registration.showNotification(notification.title, {
        body: notification.body,
        icon: notification.icon,
        badge: notification.badge,
        tag: notification.tag,
        data: { url: notification.url },
        requireInteraction: true,
        silent: false
      });

      this.recordNotificationShown(notification.userType);
      return true;
    } catch (error) {
      console.error('Failed to show immediate notification:', error);
      return false;
    }
  }

  /**
   * Get notification permission status
   */
  getPermissionStatus() {
    return Notification.permission;
  }

  /**
   * Check if service is ready
   */
  isReady() {
    return this.isInitialized && this.registration;
  }
}

// Create singleton instance
const dailyNotificationService = new DailyNotificationService();

export default dailyNotificationService;
